import api from './api';

const doctorSignatureService = {
  // Get all doctor signature profiles (optional centreId and department filters)
  getAllProfiles: async (centreId = null, department = null) => {
    const params = {};
    if (centreId) params.centreId = centreId;
    if (department) params.department = department;
    const response = await api.get('/doctor-signatures', { params });
    return response.data;
  },

  // Get specific signature profile details including history timeline
  getProfileById: async (profileId) => {
    const response = await api.get(`/doctor-signatures/${profileId}`);
    return response.data;
  },

  // Create a new doctor signature profile
  createProfile: async (payload) => {
    const response = await api.post('/doctor-signatures', payload);
    return response.data;
  },

  // Update profile details (qualifications, DMC/MCI reg no, active departments)
  updateProfile: async (profileId, payload) => {
    const response = await api.put(`/doctor-signatures/${profileId}`, payload);
    return response.data;
  },

  // Toggle active/inactive status
  updateStatus: async (profileId, status) => {
    const response = await api.patch(`/doctor-signatures/${profileId}/status`, JSON.stringify(status), {
      headers: { 'Content-Type': 'application/json' }
    });
    return response.data;
  },

  // Upload new signature image (Base64) - automatically bumps version and archives previous version
  uploadSignatureImage: async (profileId, payload) => {
    const response = await api.post(`/doctor-signatures/${profileId}/upload-signature`, payload);
    return response.data;
  },

  // Retrieve version history timeline
  getProfileHistory: async (profileId) => {
    const response = await api.get(`/doctor-signatures/${profileId}/history`);
    return response.data;
  },

  // Generate secure streaming URL for signature image preview
  getSignatureImageUrl: (profileId, version = null, historyId = null) => {
    if (historyId) {
      return `${api.defaults.baseURL}/doctor-signatures/image/history/${historyId}`;
    }
    if (version) {
      return `${api.defaults.baseURL}/doctor-signatures/image/${profileId}/v/${version}`;
    }
    return `${api.defaults.baseURL}/doctor-signatures/image/${profileId}`;
  },

  getHistorySignatureImageUrl: (historyId) => {
    return `${api.defaults.baseURL}/doctor-signatures/image/history/${historyId}`;
  },

  // Technician Delegated Approval Mappings
  getTechnicianMappings: async (profileId) => {
    const response = await api.get(`/doctor-signatures/${profileId}/technicians`);
    return response.data;
  },

  addTechnicianMapping: async (profileId, payload) => {
    const response = await api.post(`/doctor-signatures/${profileId}/technicians`, payload);
    return response.data;
  },

  updateTechnicianMapping: async (profileId, mappingId, payload) => {
    const response = await api.put(`/doctor-signatures/${profileId}/technicians/${mappingId}`, payload);
    return response.data;
  },

  toggleTechnicianStatus: async (profileId, mappingId, isActive) => {
    const response = await api.patch(
      `/doctor-signatures/${profileId}/technicians/${mappingId}/status`,
      JSON.stringify(isActive),
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  },

  deleteTechnicianMapping: async (profileId, mappingId) => {
    const response = await api.delete(`/doctor-signatures/${profileId}/technicians/${mappingId}`);
    return response.data;
  }
};

export default doctorSignatureService;
